import React from 'react';
import { Provider } from 'react-redux';
import { configureStore, combineReducers } from '@reduxjs/toolkit';

import RoutesComponent from './RoutesComponent';
import userReducer from './reducers/user';

const rootReducer = combineReducers({
  user: userReducer,
});

const store = configureStore({ reducer: rootReducer });

const App = () => {
  return (
    <Provider store={store}>
      <RoutesComponent />
    </Provider>
  );
};

export default App;
